import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Css/View.css";
import profile from "./Images/Dark Blue and Gold  Circle Logo 1 (1).png";

const SettingEdit = () => {
  const navigate = useNavigate();

 const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // later you can upload or preview this file
      console.log(file);
    }
  };

  return (
    <div className="student-page">
      {/* Header */}
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          सेटिंग्ज &gt;&gt; <span>एडिट प्रोफाइल</span>
        </h3>

        <div className="edit-btnn">
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
          <button
            className="btn primaryy"
            onClick={() => navigate("/dashboard/settings")}
          >
            सेव्ह करा
          </button>
        </div>
      </div>

      <h2>प्रोफाइल एडिट करा </h2>

     <div className="profile-card">
      <div className="profile-img-wrapper">
        <img src={profile} alt="student" className="profile-img" />

        {/* Edit Icon */}
        <label className="edit-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18" fill="none">
  <path d="M2 16H3.425L13.2 6.225L11.775 4.8L2 14.575V16ZM0 18V13.75L13.2 0.575C13.4 0.391667 13.6208 0.25 13.8625 0.15C14.1042 0.05 14.3583 0 14.625 0C14.8917 0 15.15 0.05 15.4 0.15C15.65 0.25 15.8667 0.4 16.05 0.6L17.425 2C17.625 2.18333 17.7708 2.4 17.8625 2.65C17.9542 2.9 18 3.15 18 3.4C18 3.66667 17.9542 3.92083 17.8625 4.1625C17.7708 4.40417 17.625 4.625 17.425 4.825L4.25 18H0ZM12.475 5.525L11.775 4.8L13.2 6.225L12.475 5.525Z" fill="#ffffff"/>
</svg>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            hidden
          />
        </label>
      </div>

      <p className="updated-text">Last Updated 12/12/2024</p>
    </div>

      {/* Editable Grid */}
      <div className="info-gridd">
        <div className="info-boxx">
          <label>सुपर अडमिन नाव</label>
          <input defaultValue="AKES" />
        </div>
        <div className="info-boxx">
          <label>मोबाईल नं.</label>
          <input defaultValue="९८७६५४३२१०" />
        </div>
         <div className="info-boxx">
          <label>ईमेल</label>
          <input type="email" defaultValue="priya.deshmukh@gmail.com" />
        </div>
         
         <div className="info-boxx">
          <label>वेबसाइट </label>
          <input type="text" defaultValue="www.gyandeepschool.in"/>
        </div>
         <div className="info-boxx">
          <label>पत्ता </label>
          <input type="text" defaultValue="ज्ञानदीप रोड, सातारा "/>
        </div>
       
          
      </div>
    </div> 
  );
}; 

export default SettingEdit;
